import React from 'react'
import { Wrapper, Title, Sorriso } from './style'
import { useFetchContent } from 'src/hooks/useContentful/useFetchContent'
import Loading from 'src/components/Loading'
import { getSection } from 'src/hooks/useContentful/getSection'
import Steps from './Steps'
export default function ComeceAgora() {
	const { data, isLoading } = useFetchContent()

	if (isLoading || !data) return <Loading />

	const { title, backgroundColor } = getSection({
		sectionName: 'landingStepperSection',
		data
	})
	console.log('titulo', title)
	return (
		<Wrapper style={{ backgroundColor: backgroundColor }}>
			<Title tamanho="Médio">{title}</Title>
			<Sorriso />
			<Steps />
		</Wrapper>
	)
}
